import React,{Component} from "react";
import Tab from "@material-ui/core/Tab";
import { Tabs,Box } from "@material-ui/core";
import AdminMedicalForm from "./AdminMedicalForm";
import AdminMedicalFormList from "./Adminmedicalformlist";
import AdminMedicalEdit from "./AdminMedicalEdit";
import Cookies from "universal-cookie";

const cookies = new Cookies();

//const axios = require("axios");
//const ref = React.createRef();
export default class AdminMedicalTab extends Component{
    constructor(props)
    {
        super(props);
           this.state={value:0,tab1:"block",tab2:"none",tab3:"none",path:cookies.get("phpclass").substring(0,cookies.get("phpclass").length-3)};
    }
    
    render(){
        console.log(this.state.path+"ci2");
        return(
            <div className="containera1">
{/*}             <p style={{float:"right", width:"100px"}}>KARACHI</p>*/}

{/*}                <div width="100%" align="center" height="100%" scroll="hidden" >*/}
                    <Box position="static">
                        <Tabs
                            value={this.state.value}
                            textColor="inherit"
                            indicatorColor="secondary"
                            style={{marginLeft:"50px"}}
                            onChange={(event, newValue) => {if(newValue == 0) this.setState({value:newValue,tab1:"block",tab2:"none",tab3:"none"}); else if(newValue == 1) this.setState({value:newValue,tab1:"none",tab2:"block",tab3:"none" }); else this.setState({value:newValue,tab1:"none",tab2:"none",tab3:"block" });                                                            
                            }}
                            >
                            <Tab label="By reference#" > </Tab> 
                            <Tab label="By employee id"></Tab>
                            <Tab label="Edit Form"></Tab>


                        </Tabs>
                    </Box>

                    <div  style={{display:this.state.tab1}}>
{/*}                            <AdminMedicalForm  apipath="https://d-land.pk/ci2"/>*/}
                            <AdminMedicalForm  apipath={this.state.path+"ci2"}/>
                    </div>

                    <div  style={{display:this.state.tab2}}>
                        <AdminMedicalFormList  apipath={this.state.path+"ci2"}/>
                    </div>
                    <div  style={{display:this.state.tab3}}>
                        <AdminMedicalEdit apipath={this.state.path+"ci2"}/>
                    </div>
                    <br></br><br></br>
                </div>
    )}
}
